// src/utils/dataUtils.js
export const filterAndSort = (items, filterKey = 'display', sortKey = 'order') => {
  if (!Array.isArray(items)) return [];
  
  return items
    .filter(item => item && item[filterKey])
    .sort((a, b) => (a[sortKey] || 0) - (b[sortKey] || 0));
};

export const getVisibleSections = (sections) => {
  return filterAndSort(sections);
};

export const findSectionById = (sections, id) => {
  return sections.find(section => section.id === id);
};

export const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (element) {
    const headerHeight = 80; // Account for fixed header
    const elementPosition = element.offsetTop - headerHeight;
    
    window.scrollTo({
      top: elementPosition,
      behavior: 'smooth'
    });
  }
};

export const formatDate = (dateString) => {
  const options = { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  };
  return new Date(dateString).toLocaleDateString('en-US', options);
};

export const truncateText = (text, maxLength) => {
  if (text.length <= maxLength) return text;
  return text.substr(0, maxLength) + '...';
};


